export enum SalesOrganizationId {
  DE = "1000",
  NL = "0070",
  FR = "0072",
  BE = "0077",
  CH = "0078",
  AT = "0079",
}

export const mapToSalesOrganizationId = (
  id: string | undefined,
): SalesOrganizationId | undefined => {
  if (!id) return undefined;

  return Object.values(SalesOrganizationId).find((value) => value === id);
};
